import React, { useState } from 'react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/** Вход. Своя страница, а не перенесённая из производственного сервиса:
 *  та тянет за собой переводы и общий контекст, которых здесь нет. */
export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password) return;
    setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: username.trim(), password }),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.detail || 'Неверный логин или пароль');
      localStorage.setItem('authToken', d.token);
      await onLogin();
    } catch (err) {
      toast.error(err.message);
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="funnel-ui flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4">
        <div className="mb-6">
          <h1 className="text-xl font-semibold tracking-tight">Alicor · Продажи</h1>
          {/* Цветом, а не прозрачностью: 55% непрозрачности на светлом
              сером дают контраст 1.2:1 при норме 4.5 — нашёл детектор,
              прогоняя отрисованную страницу. */}
          <p className="fn-ink-3 mt-1 text-[length:var(--fn-t-md)]">
            Заявки, звонки и переписка с клиентами
          </p>
        </div>
        {/* name и autoComplete нужны, чтобы браузер распознал форму входа и
            предложил сохранить пароль в своём менеджере. Без name он видит
            два безымянных поля и молчит — ни ошибки, ни подсказки. */}
        <div className="space-y-1.5">
          <Label htmlFor="username" className="text-xs">Логин</Label>
          <Input id="username" name="username" type="text" autoComplete="username"
                 value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="password" className="text-xs">Пароль</Label>
          <Input id="password" name="password" type="password" autoComplete="current-password"
                 value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        <button type="submit" disabled={busy || !username.trim() || !password}
                className="fn-btn fn-btn-primary w-full">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Войти
        </button>
      </form>
    </div>
  );
}
